import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Persistent banner shown to Zilch staff while they are acting on another
 * organisation's behalf (see "Access this organisation" in the admin portal).
 * Reminds them they are not in their own account and provides a quick exit.
 */
export default function ImpersonationBanner() {
  const { isImpersonating, impersonatedOrgName, stopImpersonation } = useAuth();
  const navigate = useNavigate();

  if (!isImpersonating) return null;

  const handleExit = async () => {
    await stopImpersonation();
    navigate('/admin');
  };

  return (
    <div
      style={{
        background: '#b91c1c',
        color: '#fff',
        padding: '8px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        fontSize: 14,
        fontWeight: 600,
        position: 'sticky',
        top: 0,
        zIndex: 1080,
      }}
    >
      <span>
        Viewing as <strong>{impersonatedOrgName || 'another organisation'}</strong>
        {' '}— you are acting on this organisation's behalf
      </span>
      <button
        className="btn btn-light btn-sm"
        style={{ fontWeight: 600 }}
        onClick={handleExit}
      >
        Exit
      </button>
    </div>
  );
}
